<template>
  <Login>
    <template v-slot:title>
      <span id="loginTitle">{{ $tc("Company", 1) }}</span>
      <span id="loginMessage">{{ $t("ChooseCompanyLoginMessage") }}</span>
    </template>
    <template v-slot:form>
      <form class="loginForm" @submit.prevent="submit">
        <div class="main-login-form-container">
          <div class="company-div">
            <span class="login-input-label">{{ $tc('Company', 1) }}</span>
            <treeselect
              v-model="selectedCompanyID"
              class="loginInput form-input-select select-company"
              :options="companies"
              :load-options="loadCompanies"
              :placeholder="null"
              :clearable="false"
              :class="{ fieldErrorInput: badCompany }"
              :searchable="false"
              :normalizer="normalizer"
            />
          </div>
        </div>
        <div
          v-if="badCompany"
          class="field-error-div"
          style="padding-top: 4px;"
        >
          {{ $t("ChooseCompany") }}
        </div>
      </form>
    </template>
    <template v-slot:button>
      <v-btn
        type="submit"
        :loading="loading"
        :disabled="selectedCompanyID === null"
        color="accent--text"
        @click="submit"
        class="signInInput"
        outlined
      >
        {{ $t("Continue") }}
      </v-btn>
    </template>
    <template v-slot:logoutButton>
      <v-btn
        type="execute"
        :loading="loading"
        :disabled="false"
        color="accent--text"
        @click="logout"
        class="signInInput logoutButton"
        outlined
      >
        {{ $t("Logout") }}
      </v-btn>
    </template>
  </Login>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";
import Login from "@/views/Login";

export default {
  name: "LoginCompanySelection",

  components: { Login },

  data() {
    return {
      /**
       * Stores the selected company id
       */
      selectedCompanyID: null,
      /**
       * Stores all companies available for the user to access
       */
      companies: null,
      /**
       * If the login request gives an error, this variable is set to true to be able to show an error message
       */
      badCompany: false,
      /**
       * Determines if the submit button is loading
       */
      loading: false
    };
  },

  computed: {
    companiesData() {
      return this.orderCompanies(this.$store.getters.companies);
    },

    /**
     * Determines which company is selected depending on the selectedCompanyID variable
     * @returns {{}|*}
     */
    selectedCompany() {
      if (this.selectedCompanyID) {
        return this.companies.find(
          company => company.uuid === this.selectedCompanyID
        );
      } else return {};
    }
  },

  mounted() {
    this._keyListener = e => {
      if (e.keyCode === 13) {
        e.preventDefault();
        this.submit();
      }
    };
    window.addEventListener("keyup", this._keyListener);
  },

  beforeDestroy() {
    window.removeEventListener("keyup", this._keyListener);
  },

  methods: {
    ...mapActions(["PICK_COMPANY", "GET_USER_COMPANIES", "CANCEL_LOGIN"]),
    /**
     * Get the list of user companies
     * @param callback
     */
    loadCompanies({ callback }) {
      if (this.companiesData.length > 0) {
        this.companies = this.companiesData;
        callback();
      } else {
        this.GET_USER_COMPANIES().then(resp => {
          if (resp.length > 1) {
            this.companies = this.companiesData;
          } else if (resp.length === 1) {
            this.PICK_COMPANY(resp[0]).then(() => {
              this.$router.push({ name: "hub" });
            });
          } else {
            this.$toasted.global.toast_error(
              "An error occurred. Please try again later."
            );
          }
          callback();
        });
      }
    },

    /**
     * Makes the order to store the necessary data of the selected company
     */
    submit() {
      this.loading = true;
      if (this.selectedCompanyID) {
        let finalParentCompany = this.getFinalParentCompany(this.selectedCompany)
        this.selectedCompany.final_parent = this.selectedCompany.id !== finalParentCompany.id ? finalParentCompany : null
        this.PICK_COMPANY(this.selectedCompany).then(() => {
          this.loading = false;
          this.$router.push({ name: "hub" });
        });
      } else {
        this.loading = false;
        this.badCompany = true;
      }
    },

    /**
     * Normalizer for the list of companies
     * @param node
     * @returns {{id, label}}
     */
    normalizer(node) {
      return {
        id: node.uuid,
        label: node.name
      };
    },

    /**
     * Sort companies by type and name
     * @param companies
     * @returns {unknown[]}
     */
    orderCompanies(companies) {
      return _.orderBy(companies, ["type", "name"], ["asc", "asc"]);
    },

    /**
     * Cancel the login by returning to the login page
     */
    logout() {
      this.CANCEL_LOGIN().then(() => {
        this.$router.push({ name: "login" });
      });
    },

    getFinalParentCompany(currentCompany){
      if(!currentCompany.company_id){
        return currentCompany
      }
      let parentCompany = this.companies.find(
        company => company.id === currentCompany.company_id
      );

      if (!!parentCompany) {
        currentCompany = this.getFinalParentCompany(parentCompany)
      }
      return currentCompany
    },
  }
};
</script>

<style scoped>
.logoutButton {
  margin-top: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginCompanySelection.vue